<template>
  <div>
    <l-map
      ref="map"
      style="height: 300px; width: 100%"
      :zoom="zoom"
      :center="center"
      @click="onMap"
      @update:center="resizeMap"
    >
      <l-tile-layer :url="url" />
      <l-marker :lat-lng="markerLatLng.origin">
        <l-tooltip content="مبدا" />
      </l-marker>
      <l-marker :lat-lng="markerLatLng.destination">
        <l-tooltip content="مقصد" />
      </l-marker>

      <l-polyline :lat-lngs="[markerLatLng.origin, markerLatLng.destination]" />

      <bita-bootbutton
        v-show="!acceptedOrigin"
        title="تایید مبدا"
        type="primary"
        style="position: absolute;
        z-index: 1000;
        left: 0;
        bottom: 0;"
        @click.native.stop="acceptedOrigin = true"
      ></bita-bootbutton>
    </l-map>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker, LTooltip, LPolyline } from "vue2-leaflet";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    LPolyline,
  },
  props: {
    value: {
      default: () => {
        origin: [31.83, 54.53];
        destination: [33, 49];
      },
    },
    zoom: {
      type: Number | String,
      default: 8,
    },
  },
  data() {
    return {
      latlngs: [
        [47.334852, -1.509485],
        [47.342596, -1.328731],
        [47.241487, -1.190568],
        [47.234787, -1.358337],
      ],
      markerLatLng: {
        origin: [31.83, 54.53],
        destination: [33, 49],
      },
      acceptedOrigin: false,
      center: [33, 49],
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    };
  },
  mounted() {
    this.markerLatLng = {
      origin: [31.83, 54.53],
      destination: [33, 49],
    };
    this.$emit("input", {
      origin: this.originMarker,
      destination: this.destinationMarker,
    });

    setTimeout(() => {
      this.resizeMap();
    }, 10000);
  },
  watch: {
    value(e) {
      if (e) {
        this.markerLatLng = {
          origin: [e.origin[0], e.origin[1]],
          destination: [e.destination[0], e.destination[1]],
        };
      }
    },
  },
  methods: {
    onMap(e) {
      let latlng = e.latlng;
      if (this.acceptedOrigin)
        this.markerLatLng.destination = [latlng.lat, latlng.lng];
      else this.markerLatLng.origin = [latlng.lat, latlng.lng];

      this.$emit("input", {
        origin: this.markerLatLng.origin,
        destination: this.markerLatLng.destination,
      });
    },
    resizeMap() {
      // fix: not fuly load
      this.$refs.map.mapObject._onResize();
    },
  },
};
</script>

<style lang="scss" scoped></style>
